import React, { useState, useEffect } from 'react';
import { fetchWidgetData } from '../../services/api';

function Widget() {
  const [widgetData, setWidgetData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
      let isMounted = true;
  
      const getData = async () => {
        try {
          
          const result = await fetchWidgetData();
          // console.log('getData: ',result)
          setTimeout(() => {
            if (isMounted){
              setWidgetData(result);
            }
          },500);
          
        } catch (err) {
          if (isMounted){
            setError(err);
          }
        }
      };
      getData();
      
      return () => {
        isMounted=false;
      };
    }, []);

    if (!widgetData) return <div>Loading...</div>;

  return (
    <div>
      { widgetData.pts_available_count === 'NA' ? (
        <section className="bg-white p-1.5">
        <div className="border-blue-700 flex items-center">
      
          <div className="flex-none">
            <img src="/rewards-icon-0-pts.svg" className="px-4 py-2" alt="" />
          </div>
      
          <div className="py-2">
            <div>
              <p className="text-gray-800 text-lg text-left leading-6 mb-2">Learn how to <span className="text-blue-700">earn points with every swipe</span>.</p>
             {/* <p><a target="_top" href="https://rewards.plugins.mymax.com" className="mt-2 inline-block w-auto bg-blue-700 border border-transparent rounded-full py-1 px-4 text-xs font-bold text-white text-center hover:bg-blue-800 hover:text-white">Learn More</a></p> */}

            </div>
          </div>
        </div>
      
      </section>
      ) : parseFloat(widgetData.pts_available_count.replace(/,/g, '')) >= 500 ? (
        <section class="bg-white">
          <div class="border-blue-700 flex items-center">

            <div class="flex-none">
              <img src="/rewards-icon-500-pts.svg" class="px-4 py-2" alt="" />
            </div>

            <div class="py-2">
              <div>
                <p class="text-gray-800 text-lg text-left leading-6 mb-2">You have <span class="font-bold text-blue-700">{ widgetData.pts_available_count } rewards points</span> worth <span class="font-bold">${ widgetData.pts_available_worth }</span></p>
                {/*<p><a target="_top" href="https://rewards.plugins.mymax.com/redeem" class="mt-2 inline-block w-auto bg-white border border-transparent rounded-full py-1 px-4 text-xs font-bold text-blue-700 text-center hover:bg-blue-50 hover:text-blue-700">Redeem Points</a></p> */}
              </div>
            </div>
          </div>

        </section>
      ) : parseFloat(widgetData.pts_available_count.replace(/,/g, '')) >= 300 ? (
        <section class="bg-white">
          <div class="border-blue-700 flex items-center">

            <div class="flex-none">
              <img src="/rewards-icon-300-pts.svg" class="px-4 py-2" alt="" />
            </div>

            <div class="py-2">
              <div>
                <p class="text-gray-800 text-lg text-left leading-6 mb-2">You have <span class="font-bold text-blue-700">{ widgetData.pts_available_count } points</span>.</p>
                {/* <p class="text-gray-800 text-base text-left leading-6">Earn 500 points to redeem.</p> */}
                <p><strong>Earn 500 Points to Redeem</strong></p>
              </div>
            </div>
          </div>

        </section>

      ) : widgetData.pts_available_count === 'DOWN' ? (
        <section class="bg-white">
          <div class="border-blue-700 flex items-center">
        
            <div class="flex-none">
              <img src="/rewards-icon-0-pts.svg" class="px-4 py-2" alt="" />
            </div>
        
            <div class="py-2">
              <div>
                <p class="text-gray-800 text-lg text-left leading-6 mb-2">Learn how to <span class="text-blue-700">earn points with every swipe</span>.</p>
               {/*} <p><a target="_top" href="https://rewards.plugins.mymax.com" class="btnGoToRewards mt-2 inline-block w-auto bg-blue-700 border border-transparent rounded-full py-1 px-4 text-xs font-bold text-white text-center hover:bg-blue-800 hover:text-white">Learn More</a></p> */}
              </div>
            </div>
          </div>
        
        </section>
      ) : (
        <section class="bg-white">
          <div class="border-blue-700 flex items-center">

            <div class="flex-none">
              <img src="/rewards-icon-0-pts.svg" class="px-4 py-2" alt="" />
            </div>

            <div class="py-2">
              <div>
                <p class="text-gray-800 text-lg text-left leading-6 mb-2">Learn how to <span class="text-blue-700">earn points with every swipe</span>.</p>
              {/*  <p><a target="_top" href="https://rewards.plugins.mymax.com" class="btnGoToRewards mt-2 inline-block w-auto bg-blue-700 border border-transparent rounded-full py-1 px-4 text-xs font-bold text-white text-center hover:bg-blue-800 hover:text-white">Learn More</a></p> */}
              </div>
            </div>
          </div>

        </section>

      )}
    </div>
  );
}

export default Widget;